import { createFileRoute } from "@tanstack/react-router";

import { ChartOfAccounts } from "@/features/settings/chart-of-accounts";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_settings/einstellungen/kontenplan",
)({
  component: ChartOfAccountsScreen,
});

function ChartOfAccountsScreen() {
  return <ChartOfAccounts />;
}
